module.exports = __webpack_public_path__ + "img/social-media.328fc361.svg";